import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
  selector: 'app-olps-temperatur',
  templateUrl: './olps-temperatur.component.html',
  styleUrls: ['./olps-temperatur.component.scss',
      './../card.scss'],
    standalone: false
})
export class OlpsTemperaturComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Temp: Property<any>;
    @Input() Type: string;

    constructor()
    {
        super('olps-temperatur');
        this.chart = true;
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges)
    {

    }
}
